import { IEndOfMonthFlow, IPrimeRate } from '@common/interfaces/loanServicing'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import { EXPORT_CLIENT_FEE_STATEMENT_REQUEST } from './../clientInfo/actions'
import * as actions from './actions'

export interface IPortfolioLoanBalanceGraphData {
  labels: string[]
  datasets: {
    label: string
    data: number[]
  }[]
  utilization?: number[]
  clientCounts?: number[]
}

export default combineReducers({
  loadingArray: loadingArrayReducer([
    actions.prefix,
    EXPORT_CLIENT_FEE_STATEMENT_REQUEST.replace('_REQUEST', ''),
  ]),
  loanBalanceStartDate(state: string | null = null, action: IAction): string | null {
    switch (action.type) {
      case actions.GET_LOAN_BALANCE_START_DATE_SUCCESS:
        return action.data as string | null
      default:
        return state
    }
  },
  primeRate(state: IPrimeRate | null = null, action: IAction): IPrimeRate | null {
    switch (action.type) {
      case actions.GET_PRIME_RATE_SUCCESS:
        return action.data as IPrimeRate | null
      default:
        return state
    }
  },
  endOfMonthFlow(state: IEndOfMonthFlow | null = null, action: IAction): IEndOfMonthFlow | null {
    switch (action.type) {
      case actions.GET_END_OF_MONTH_FLOW_SUCCESS:
        return action.data as IEndOfMonthFlow | null
      default:
        return state
    }
  },
  portfolioLoanBalanceGraph: createLoadingDataReducer<IPortfolioLoanBalanceGraphData>([
    actions.GET_PORTFOLIO_LOAN_BALANCE_GRAPH_REQUEST,
  ]),
})
